import classNames from 'classnames';
import {Typography} from 'components/Typography';
import Icon from 'components/Icon';
import style from '../style.module.scss';

interface IProps {
    showOverlay: boolean;
    onOverlayClick: () => void;
}

export const FilterOverlay = ({showOverlay, onOverlayClick}: IProps) => {
    return (
        <div
            className={classNames(style.filterOverlay, {[style.filterOverlayShow]: showOverlay})}
            onClick={onOverlayClick}
        >
            <Typography className={style.filterText} variant={'button-s'}>
                Все фильтры
            </Typography>
            <Icon icon={'filter-icon'} />
        </div>
    );
};
